import { Control, Controller, FieldPath, FieldValues } from 'react-hook-form';

import Stack from '@mui/material/Stack';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';

interface SharedFormCheckboxProps<T extends FieldValues> {
  control: Control<T>;
  name: FieldPath<T>;
  label: string;
  helperText?: string;
  disabled?: boolean;
  onChange?: (checked: boolean) => void;
}

export default function SharedFormCheckbox<T extends FieldValues>({
  control,
  name,
  label,
  helperText,
  disabled,
  onChange,
}: SharedFormCheckboxProps<T>) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Stack spacing={0}>
          <FormControlLabel
            control={
              <Checkbox
                {...field}
                checked={!!field.value}
                disabled={disabled}
                onChange={(event) => {
                  const checked = event.target.checked;
                  field.onChange(checked);
                  onChange?.(checked);
                }}
              />
            }
            label={label}
            sx={{ width: 'fit-content' }}
          />

          {helperText && (
            <FormHelperText sx={{ pl: 4, mt: -0.5 }}>
              {helperText}
            </FormHelperText>
          )}
        </Stack>
      )}
    />
  );
}
